var exports = {
  "i": "x31de4314--ca5a3e--wrapper",
};

module.exports = exports;
